import React, { Fragment } from 'react';
import { ModalType, useFormikTransferFilters } from '../../../../utils';
import TransfersView from '../Views/TransfersView';
import { TransfersFilter } from '../../types/transfers-response';
import { useFetchTransferRequests, useFetchTransferById, useCancelTransfer, useFetchTransferByIdItems } from '../../../../hooks';
import { ShareResponse} from '../../../../share';
import TransfersCreateContainer from './TransfersCreateContainer';
import TransfersDetailContainer from './TransfersDetailContainer';
import { useCustomToast } from '../../../../components';
import { authAtom } from '../../../../state';
import { useAtom } from 'jotai';
import { modalStateAtom } from '../../../../state/atoms';

const TransfersContainer: React.FC = () => {
  //manage state modal
  const [modalState, setModalState] = React.useState<{
    type: ModalType;
    id?: string;
  }>({ type: null, id: undefined });

  const transferStates: ShareResponse[] = [
    { id: '8', name: 'Por aprobar' },
    { id: '10', name: 'Rechazado' },
    { id: '12', name: 'Por registrar' },
    { id: '11', name: 'Anulado' },
    { id: '7', name: 'Finalizado' },
  ];
  
  const [authData] = useAtom(authAtom);
  const [modalAtom, setModalAtom] = useAtom<boolean>(modalStateAtom);
  const [filter, setFilter] = React.useState<TransfersFilter>({
    requester_id: authData?.user.id,
  });
  const {
    data: tranfers,
    isPending: loadList,
    refetch,
  } = useFetchTransferRequests(filter);
  const { data: transfer, isPending: loadById } = useFetchTransferById(modalState.id);
  const { data: items, isLoading: loadingItems } = useFetchTransferByIdItems(
    modalState.id
  );

  const { mutateAsync: updateGestorItems } = useCancelTransfer();
  
  const handleModalToggle = (type: ModalType, id?: string) => {
     setModalState({
      type: type,
      id: id,
    });
    setModalAtom(false);
  };

   const handleViewCreate = () => {
    setModalState({ type: 'create', id: undefined });
  };

  const handleViewDetail = (id: string) => {
    setModalState({ type: 'detail', id: id });
  };

  const handlePagination = (page: number) => {
    setFilter({
      page: page.toString(),
    });
  };

  const handleFilter = async (values: Partial<TransfersFilter>) => {
      const finalFilter = {
        ...values,
        requester_id: authData?.user.id,
        created_at: values.created_at
          ? new Date(values.created_at).toISOString().split('T')[0]
          : '',
      };
    
      setFilter(finalFilter);
    };

  const onCancelRequest = async (id: string, reason: string) => {
    const { showToast } = useCustomToast();

    try {
      await updateGestorItems({ id, data: { reason } });

      showToast('success', 'Solicitud de traslado ha sido anulada.');
    } catch (error) {
      showToast('error', 'Error al anular solicitud.');
    }

  };

  const formik = useFormikTransferFilters({ onSubmit: handleFilter });

  return (
    <Fragment>
      <TransfersCreateContainer
        isOpen={modalState.type === 'create' || modalAtom}
        OnClose={() => handleModalToggle(null)}
      />

      <TransfersDetailContainer
        isOpen={modalState.type === 'detail'}
        OnClose={() => handleModalToggle(null)}
        data={transfer}
        isLoading={loadById}
        items={items}
        isLoadingItems={loadingItems}
      />

      <TransfersView
        isLoading={loadList}
        data={tranfers}
        states={transferStates}
        formik={formik}
        onViewCreate={handleViewCreate}
        onViewDetail={handleViewDetail}
        onPagination={handlePagination}
        onResetFilters={() => {
          handleFilter({});
          formik.resetForm();
        }}
        onCancelRequest={onCancelRequest}
      />
    </Fragment>
  );
};

export default TransfersContainer;